module.exports = __webpack_public_path__ + "static/media/shopping-basket.df790696.svg";